import React from 'react';

function InstagramFeed() {
  const instagramPosts = [
    {
      id: 1,
      src: "https://www.instagram.com/p/DL73ZifsKP1/embed/", // Remplacer par l'URL d'embed réelle
      title: "Publication Instagram 1"
    },
    {
      id: 2,
      src: "https://www.instagram.com/p/DLkmqQvIjN0/embed/", // Remplacer par l'URL d'embed réelle
      title: "Publication Instagram 2"
    },
    {
      id: 3,
      src: "https://www.instagram.com/p/DLXsFsWIQF3/embed/", // Remplacer par l'URL d'embed réelle
      title: "Publication Instagram 3"
    }
  ];

  const instagramProfileUrl = "https://www.instagram.com/votre_profil_instagram/"; 

  return (
    <section className="instagram-section">
      <h2 className="instagram-title">Suivez-nous sur Instagram !</h2>
      <p className="section-subtitle">
        Découvrez nos fromages, nos événements et la vie de la ferme en images.
      </p>

      <div className="instagram-grid">
        {instagramPosts.map(post => (
          <div key={post.id} className="instagram-post-container">
            <iframe
              src={post.src}
              width="375" // Largeur recommandée par Instagram, gérée par CSS via max-width
              height="600" // Hauteur ajustée, gérée par CSS
              // AJUSTEMENT: Les styles inline ont été retirés et déplacés vers InstagramFeed.css
              scrolling="no"
              frameBorder="0"
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              title={post.title}
              loading="lazy"
            ></iframe>
          </div>
        ))}
      </div>

      <div className="instagram-footer">
        <a
          href={instagramProfileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          Voir plus sur Instagram
        </a>
      </div>
    </section>
  );
}

export default InstagramFeed;